import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import {
  BrazoArticulado_1,
  CargadoresFrontales_1,
  Compactadoras_1,
  Excavadora_6,
  Manipuladores_2,
  Minicargadores_6,
  Miniexcavadoras_3,
  Montacargas_2,
  PlataformasAltura_1,
  Retroexcavadora_1,
  Teletruk_1,
} from '../../assets/images';

const Machinery = () => {
  const machineryList = [
    {
      id: 1,
      name: 'Brazos Articulados',
      slug: 'brazoarticulado',
      description: 'Brazos articulados con máxima versatilidad y alcance para todo tipo de trabajos.',
      image: BrazoArticulado_1,
      alt: 'Brazo Articulado JCB - Máquina para trabajos en altura con máxima versatilidad y alcance'
    },
    {
      id: 2,
      name: 'Cargadores Frontales',
      slug: 'cargadoresfrontales',
      description: 'Cargadores frontales con gran capacidad de carga y rendimiento excepcional.',
      image: CargadoresFrontales_1,
      alt: 'Cargador Frontal JCB - Equipo de alta capacidad de carga para minería y agregados'
    },
    {
      id: 3,
      name: 'Compactadoras',
      slug: 'compactadoras',
      description: 'Compactadoras de alto rendimiento para trabajos de compactación eficientes.',
      image: Compactadoras_1,
      alt: 'Compactadora JCB - Rodillo vibratorio en tándem para trabajos de compactación'
    },
    {
      id: 4,
      name: 'Excavadoras',
      slug: 'excavadoras',
      description: 'Excavadoras potentes con tecnología de punta para máxima productividad.',
      image: Excavadora_6,
      alt: 'Excavadora JCB sobre orugas - Máquina de excavación de alto rendimiento'
    },
    {
      id: 5,
      name: 'Manipuladores Telescópicos',
      slug: 'manipuladorestelescopicos',
      description: 'Manipuladores telescópicos con gran alcance y capacidad de elevación.',
      image: Manipuladores_2,
      alt: 'Manipulador Telescópico JCB Loadall - Equipo de elevación con gran alcance'
    },
    {
      id: 6,
      name: 'Minicargadores',
      slug: 'minicargadores',
      description: 'Minicargadores compactos ideales para espacios reducidos.',
      image: Minicargadores_6,
      alt: 'Minicargador JCB - Equipo compacto con diseño de brazo único para espacios reducidos'
    },
    {
      id: 7,
      name: 'Miniexcavadoras',
      slug: 'miniexcavadoras',
      description: 'Miniexcavadoras versátiles para trabajos en espacios confinados.',
      image: Miniexcavadoras_3,
      alt: 'Miniexcavadora JCB - Máquina compacta para excavación en espacios confinados'
    },
    {
      id: 8,
      name: 'Montacargas',
      slug: 'montacargas',
      description: 'Montacargas de alto rendimiento para manejo de materiales.',
      image: Montacargas_2,
      alt: 'Montacargas Todo Terreno JCB - Equipo de manejo de materiales en terrenos accidentados'
    },
    {
      id: 9,
      name: 'Plataformas de Altura',
      slug: 'plataformadealtura',
      description: 'Plataformas de altura seguras y eficientes para trabajos en elevación.',
      image: PlataformasAltura_1,
      alt: 'Plataforma de Altura JCB Access - Tijera eléctrica certificada EN280'
    },
    {
      id: 10,
      name: 'Retroexcavadoras',
      slug: 'retroexcavadora',
      description: 'Retroexcavadoras con máxima potencia y versatilidad en obra.',
      image: Retroexcavadora_1,
      alt: 'Retroexcavadora JCB - La retroexcavadora más vendida del mundo desde 1953'
    },
    {
      id: 11,
      name: 'Teletruk',
      slug: 'teletruk',
      description: 'Teletruk con capacidad de elevación y manipulación avanzada.',
      image: Teletruk_1,
      alt: 'Teletruk JCB - Carretilla elevadora con brazo telescópico en lugar de mástil vertical'
    }
  ];

  return (
    <div className="container mx-auto px-6 py-24">
      <Helmet>
        <title>Maquinaria JCB en Venta | JCB Azteca</title>
        <meta name="description" content="Catálogo completo de maquinaria JCB: excavadoras, retroexcavadoras, cargadores frontales, minicargadores, manipuladores telescópicos, montacargas y más." />
        <meta name="keywords" content="maquinaria JCB, excavadoras, retroexcavadoras, cargadores frontales, minicargadores, manipuladores telescópicos, montacargas, teletruk, JCB Azteca" />
        <link rel="canonical" href="https://azteca-site.org/machinery" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Maquinaria JCB en Venta | JCB Azteca" />
        <meta property="og:description" content="Catálogo completo de maquinaria JCB: excavadoras, retroexcavadoras, cargadores frontales, minicargadores y más." />
        <meta property="og:url" content="https://azteca-site.org/machinery" />
        <meta property="og:image" content="https://azteca-site.org/og/maquinaria-jcb-azteca.jpg" />
        <meta property="og:locale" content="es_MX" />
        <meta property="og:site_name" content="JCB Azteca" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Maquinaria JCB en Venta | JCB Azteca" />
        <meta name="twitter:description" content="Catálogo completo de maquinaria JCB." />
        <meta name="twitter:image" content="https://azteca-site.org/og/maquinaria-jcb-azteca.jpg" />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": "Maquinaria JCB en Venta",
            "url": "https://azteca-site.org/machinery",
            "description": "Catálogo completo de maquinaria JCB: excavadoras, retroexcavadoras, cargadores frontales, minicargadores y más.",
            "inLanguage": "es-MX",
            "isPartOf": {
              "@type": "WebSite",
              "name": "JCB Azteca",
              "url": "https://azteca-site.org/"
            },
            "hasPart": [
              {
                "@type": "Product",
                "name": "Brazos Articulados JCB",
                "url": "https://azteca-site.org/machinery/brazoarticulado",
                "description": "Brazos articulados con máxima versatilidad y alcance para todo tipo de trabajos.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Cargadores Frontales JCB",
                "url": "https://azteca-site.org/machinery/cargadoresfrontales",
                "description": "Cargadores frontales con gran capacidad de carga y rendimiento excepcional.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Compactadoras JCB",
                "url": "https://azteca-site.org/machinery/compactadoras",
                "description": "Compactadoras de alto rendimiento para trabajos de compactación eficientes.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Excavadoras JCB",
                "url": "https://azteca-site.org/machinery/excavadoras",
                "description": "Excavadoras potentes con tecnología de punta para máxima productividad.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Manipuladores Telescópicos JCB",
                "url": "https://azteca-site.org/machinery/manipuladorestelescopicos",
                "description": "Manipuladores telescópicos con gran alcance y capacidad de elevación.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Minicargadores JCB",
                "url": "https://azteca-site.org/machinery/minicargadores",
                "description": "Minicargadores compactos ideales para espacios reducidos.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Miniexcavadoras JCB",
                "url": "https://azteca-site.org/machinery/miniexcavadoras",
                "description": "Miniexcavadoras versátiles para trabajos en espacios confinados.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Montacargas JCB",
                "url": "https://azteca-site.org/machinery/montacargas",
                "description": "Montacargas de alto rendimiento para manejo de materiales.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Plataformas de Altura JCB",
                "url": "https://azteca-site.org/machinery/plataformadealtura",
                "description": "Plataformas de altura seguras y eficientes para trabajos en elevación.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Retroexcavadoras JCB",
                "url": "https://azteca-site.org/machinery/retroexcavadora",
                "description": "Retroexcavadoras con máxima potencia y versatilidad en obra.",
                "brand": { "@type": "Brand", "name": "JCB" }
              },
              {
                "@type": "Product",
                "name": "Teletruk JCB",
                "url": "https://azteca-site.org/machinery/teletruk",
                "description": "Teletruk con capacidad de elevación y manipulación avanzada.",
                "brand": { "@type": "Brand", "name": "JCB" }
              }
            ]
          })}
        </script>
      </Helmet>

      <nav className="text-sm mb-12" aria-label="Breadcrumb">
        <Link to="/" className="text-text-muted hover:text-dark-primary">Inicio</Link>
        <span className="mx-2 text-text-muted">/</span>
        <span className="text-dark-primary font-medium">Maquinaria</span>
      </nav>

      <div className="max-w-3xl mb-12">
        <h1 className="text-4xl md:text-5xl font-display font-bold text-dark-primary mb-4">
          Nuestra Maquinaria
        </h1>
        <p className="text-text-muted text-lg">
          Descubre nuestra amplia gama de maquinaria JCB, diseñada para ofrecer el máximo
          rendimiento y productividad en cada proyecto.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {machineryList.map((item) => (
          <Link
            key={item.id}
            to={`/machinery/${item.slug}`}
            className="group bg-white border border-border-subtle hover:shadow-lg transition-all duration-300 overflow-hidden"
            title={`${item.name} JCB`}
          >
            <div className="aspect-[4/3] overflow-hidden bg-surface-subtle">
              <img
                src={item.image}
                alt={item.alt}
                title={`${item.name} JCB`}
                loading="lazy"
                width="600"
                height="450"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6">
              <h2 className="font-display text-lg font-bold text-dark-primary mb-2 group-hover:text-jcb-yellow transition-colors">
                {item.name}
              </h2>
              <p className="text-text-muted text-sm mb-4 line-clamp-2">
                {item.description}
              </p>
              <span className="inline-flex items-center font-display text-xs uppercase tracking-luxury text-dark-primary group-hover:text-jcb-yellow transition-colors">
                Saber Más
                <svg
                  className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                </svg>
              </span>
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-16 bg-surface-subtle p-8 md:p-12 text-center">
        <h2 className="text-2xl font-display font-bold text-dark-primary mb-4">
          ¿Necesitas ayuda para elegir la maquinaria adecuada?
        </h2>
        <p className="text-text-muted mb-6 max-w-2xl mx-auto">
          Nuestro equipo de expertos está listo para asesorarte y encontrar la solución perfecta para tu proyecto.
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center font-display text-xs uppercase tracking-luxury font-medium bg-dark-primary text-white hover:bg-black px-8 py-3 transition-all duration-300"
          title="Contactar a JCB Azteca"
        >
          Contactar ahora
        </Link>
      </div>
    </div>
  );
};

export default Machinery;